import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-variables-intelligence-market',
  templateUrl: './select-variables-intelligence-market.component.html',
  styleUrls: ['./select-variables-intelligence-market.component.scss']
})
export class SelectVariablesIntelligenceMarketComponent implements  OnDestroy {

  public items: any[] = [
    { name: 'Precio Venta', value: 'selling_price' },
    { name: 'Margen TAR', value: 'margin_tar' },
    // { name: 'Indice de Precioss', value: 'quotient' },
    // { name: 'Posición Mercado', value: 'market_position' }
  ];

  public variableSelected: any = [];
  public ngxDisabled = true;
  variableSelected$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.variableSelected$ = sharedService.sharedVariable.subscribe((variableSelected: string) => {
      if (this.variableSelected !== variableSelected) {
        this.variableSelected = variableSelected;
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.variableSelected$.unsubscribe();
  }

  changeVariable(event: any) {
    // Normalize the event value (can be primitive, array, or object)
    let value: any;
    if (event === null || event === undefined) {
      value = null;
    } else if (Array.isArray(event)) {
      value = event.length > 0 ? event[0] : null;
    } else if (typeof event === 'object' && event.value !== undefined) {
      value = event.value;
    } else {
      value = event;
    }
    
    this.variableSelected = value;
    this.sharedService.nextVariable = this.variableSelected;
  }

  isSelected(option: any): boolean {
    if (!this.variableSelected || (Array.isArray(this.variableSelected) && this.variableSelected.length === 0) || this.variableSelected === '' || this.variableSelected === null || this.variableSelected === undefined) {
      return false;
    }
    
    // Extract the primitive selected value
    let selectedValue: any;
    if (Array.isArray(this.variableSelected)) {
      selectedValue = this.variableSelected.length > 0 ? this.variableSelected[0] : null;
    } else if (typeof this.variableSelected === 'object' && this.variableSelected !== null) {
      selectedValue = this.variableSelected.value !== undefined ? this.variableSelected.value : this.variableSelected;
    } else {
      selectedValue = this.variableSelected;
    }
    
    // Normalize selectedValue if it's an object
    if (typeof selectedValue === 'object' && selectedValue !== null) {
      selectedValue = selectedValue.value !== undefined ? selectedValue.value : selectedValue;
    }
    
    return option.value === selectedValue;
  }

}
